export default __webpack_public_path__ + "static/media/online-service.0a927b7e.png";